import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
} from '@mui/material';
import AdministratorsApi from '../../api/administrators';
import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import Loading from '../Loading';
import { showError } from '../../actions/uiActions';
import { connect } from 'react-redux';
import ForgivenessModal from '../../forms/ForgivenessModal';
import Formatter from '../../utils/Formatter';
import {
    forgivenessType,
    perkinsCancellation,
} from '../../forms/Archive/forgvenessType';
import DefaultForgivenessModal from '../../forms/ForgivenessModal/DefaultForgivenessModal';
import { Edit } from '@mui/icons-material';

const Forgiveness = ({ account }) => {
    const [loading, setIsLoading] = useState(true);
    const [forgiveness, setForgiveness] = useState([]);
    const [nonDefaultLoans, setNonDefaultLoans] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showDefaultModal, setShowDefaultModal] = useState(false);
    const [loanOutOfDefault, setLoanOutOfDefault] = useState();
    const forgivenessTypes = [...forgivenessType, perkinsCancellation];
    const [editForgiveness, setEditForgiveness] = useState(null);

    const getForgivenessAndLoans = async () => {
        try {
            setIsLoading(true);

            const [forgivenessData, nonDefaultLoansData] = await Promise.all([
                AdministratorsApi.userForgiveness(account._id),
                AdministratorsApi.loansOutOfDefault(account._id),
            ]);
            setForgiveness(forgivenessData || []);
            setNonDefaultLoans(nonDefaultLoansData || []);
        } catch (error) {
            this.props.showError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getForgivenessAndLoans();
    }, []);

    const totalAmount = useMemo(() => {
        return nonDefaultLoans.reduce((acc, value) => acc + value.amount, 0);
    }, [nonDefaultLoans]);

    const getForgivenessType = (type) => {
        return (
            forgivenessTypes.find((each) => each.value === type?.toLowerCase())
                .label ?? ''
        );
    };
    return (
        <div className='col-12 forgiveness'>
            <div
                className='row'
                style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
                <button
                    className='btn btn-primary btn-standard mr-2'
                    onClick={() => setShowModal(true)}
                    disabled={!!account.isArchived}
                >
                    Add partial forgiveness
                </button>
                <button
                    className='btn btn-primary btn-standard mr-2'
                    onClick={() => setShowDefaultModal(true)}
                    disabled={!!account.isArchived}
                >
                    Add default loan amount
                </button>
            </div>
            <Paper>
                {!loading && (
                    <>
                        {forgiveness.length > 0 && (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='text-center' colSpan={9}>
                                            User Forgiveness
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Forgiveness Type</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Refund Amount</TableCell>
                                        <TableCell>Category</TableCell>
                                        <TableCell>Added by</TableCell>
                                        <TableCell>Date Received</TableCell>
                                        <TableCell>Date Created</TableCell>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {forgiveness.map((each) => (
                                        <TableRow key={each._id}>
                                            <TableCell>{getForgivenessType(each.type)}</TableCell>
                                            <TableCell>{`$${Formatter.money(
                                                each.amount,
                                            )}`}</TableCell>
                                            <TableCell>{`$${Formatter.money(
                                                each.refund,
                                            )}`}</TableCell>
                                            <TableCell>{each.category}</TableCell>
                                            <TableCell>{each.admin.name}</TableCell>
                                            <TableCell>
                                                {moment(each.dateReceived).format('MM/DD/YYYY')}
                                            </TableCell>
                                            <TableCell>
                                                {moment(each.createdAt).format('MM/DD/YYYY')}
                                            </TableCell>
                                            <TableCell>{each.description || ''}</TableCell>
                                            <TableCell>
                                                <Tooltip title='Edit Forgiveness'>
                                                    <IconButton
                                                        onClick={() => {
                                                            setEditForgiveness(each);
                                                            setShowModal(true);
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                        <div className='mt-4'>
                            {nonDefaultLoans.length > 0 && (
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='text-center' colSpan={9}>
                                                Loans Out of Default
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Loan Name</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Date(Out of Default)</TableCell>
                                            <TableCell>Date Created</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {nonDefaultLoans.map((each) => (
                                            <TableRow key={each._id}>
                                                <TableCell>{each.loanName}</TableCell>
                                                <TableCell>{`$${Formatter.money(
                                                    each.amount,
                                                )}`}</TableCell>
                                                <TableCell>
                                                    {moment(each.repaymentDate).format('MM/DD/YYYY')}
                                                </TableCell>
                                                <TableCell>
                                                    {moment(new Date(each.date * 1000)).format(
                                                        'MM/DD/YYYY',
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title='Edit Loan Out Of Default'>
                                                        <IconButton
                                                            onClick={() => {
                                                                setLoanOutOfDefault(each);
                                                                setShowDefaultModal(true);
                                                            }}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell>Total</TableCell>
                                            <TableCell
                                                style={{ fontWeight: 700 }}
                                            >{`$${Formatter.money(totalAmount)}`}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            )}
                        </div>
                    </>
                )}
                {loading && (
                    <div className='row'>
                        <div className='col-6 offset-3 text-center'>
                            <Loading message='Loading outcome...' />
                        </div>
                    </div>
                )}
            </Paper>
            {showModal && (
                <ForgivenessModal
                    userId={account._id}
                    onClose={() => {
                        setShowModal(false);
                        setEditForgiveness(null);
                    }}
                    onSuccess={() => getForgivenessAndLoans()}
                    forgiveness={editForgiveness}
                />
            )}
            {showDefaultModal && (
                <DefaultForgivenessModal
                    loanOutOfDefault={loanOutOfDefault}
                    userId={account._id}
                    onClose={() => {
                        setShowDefaultModal(false);
                        setLoanOutOfDefault(null);
                    }}
                    onSuccess={() => getForgivenessAndLoans()}
                />
            )}
        </div>
    );
};
export default connect(null, { showError })(Forgiveness);
